module.exports = __webpack_public_path__ + "static/scale-model-of-boulder-walking-tours-in-boulder-colorado-dc00ba53c016f0581f3e422cf5409df3.png";